/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export const relaxedHandPose = {
    jointTransforms: {
        wrist: {
            offsetMatrix: [
                0.9616971015930176, -0.13805118203163147, 0.2368120402097702, 0,
                0.0005348679260350764, 0.8648636937141418, 0.5020061135292053, 0,
                -0.2741127610206604, -0.48265108466148376, 0.8318111300468445, 0,
                -0.04913589730858803, 0.0021463718730956316, 0.11701996624469757, 1,
            ],
            radius: 0.021460847929120064,
        },
        'thumb-metacarpal': {
            offsetMatrix: [
                -0.07536252588033676, -0.9959676265716553, -0.04867160692811012, 0,
                0.5877083539962769, -0.08379616588354111, 0.8047218918800354, 0,
                -0.8055551648139954, 0.032041035592556, 0.5916536450386047, 0,
                -0.010643752291798592, 0.0006936835707165301, 0.08736639469861984, 1,
            ],
            radius: 0.019382517784833908,
        },
        'thumb-phalanx-proximal': {
            offsetMatrix: [
                0.1374533325433731, -0.9904957413673401, 0.004982374142855406, 0,
                0.5534393787384033, 0.08097179979085922, 0.8289443850517273, 0,
                -0.8214688897132874, -0.11118389666080475, 0.559309184551239, 0,
                0.015547193586826324, -0.0003480653394944966, 0.0681300163269043, 1,
            ],
            radius: 0.01228295173496008,
        },
        'thumb-phalanx-distal': {
            offsetMatrix: [
                -0.04659227654337883, -0.9974699020385742, -0.05369402840733528, 0,
                0.6812446117401123, -0.07104194164276123, 0.728600800037384, 0,
                -0.7305715084075928, -0.002631746232509613, 0.6828309893608093, 0,
                0.04330715537071228, 0.003409178927540779, 0.0492292083799839, 1,
            ],
            radius: 0.009768804535269737,
        },
        'thumb-tip': {
            offsetMatrix: [
                -0.04659227654337883, -0.9974699020385742, -0.05369402840733528, 0,
                0.6812446117401123, -0.07104194164276123, 0.728600800037384, 0,
                -0.7305715084075928, -0.002631746232509613, 0.6828309893608093, 0,
                0.062003348022699356, 0.004069602582603693, 0.03322213143110275, 1,
            ],
            radius: 0.008768804371356964,
        },
        'index-finger-metacarpal': {
            offsetMatrix: [
                0.9616971015930176, -0.13805118203163147, 0.2368120402097702, 0,
                0.0005348679260350764, 0.8648636937141418, 0.5020061135292053, 0,
                -0.2741127610206604, -0.48265108466148376, 0.8318111300468445, 0,
                -0.02009812369942665, 0.008770795539021492, 0.08660387247800827, 1,
            ],
            radius: 0.021228281781077385,
        },
        'index-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9001791477203369, -0.2598813474178314, 0.3494834005832672, 0,
                0.06073702871799469, 0.8695210218429565, 0.490146666765213, 0,
                -0.4312632381916046, -0.41999316215515137, 0.7985095381736755, 0,
                -0.00017739279428496957, 0.03890012577176094, 0.039073407649993896, 1,
            ],
            radius: 0.010295259766280651,
        },
        'index-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9082008600234985, -0.20898112654685974, 0.36262574791908264, 0,
                0.11045389622449875, 0.9553793668746948, 0.27395179867744446, 0,
                -0.40369608998298645, -0.20874978601932526, 0.8907597661018372, 0,
                0.01617925800383091, 0.05482936650514603, 0.008788082748651505, 1,
            ],
            radius: 0.00853810179978609,
        },
        'index-finger-phalanx-distal': {
            offsetMatrix: [
                0.9309692978858948, -0.16783711314201355, 0.32423174381256104, 0,
                0.1080828532576561, 0.9749603867530823, 0.1943446695804596, 0,
                -0.34873148798942566, -0.14588497579097748, 0.9257990717887878, 0,
                0.02599053829908371, 0.059902746230363846, -0.012860597111284733, 1,
            ],
            radius: 0.007636196445673704,
        },
        'index-finger-tip': {
            offsetMatrix: [
                0.9309692978858948, -0.16783711314201355, 0.32423174381256104, 0,
                0.1080828532576561, 0.9749603867530823, 0.1943446695804596, 0,
                -0.34873148798942566, -0.14588497579097748, 0.9257990717887878, 0,
                0.03362493962049484, 0.06421422213315964, -0.033461250364780426, 1,
            ],
            radius: 0.006636196281760931,
        },
        'middle-finger-metacarpal': {
            offsetMatrix: [
                0.9616971015930176, -0.13805118203163147, 0.2368120402097702, 0,
                0.0005348679260350764, 0.8648636937141418, 0.5020061135292053, 0,
                -0.2741127610206604, -0.48265108466148376, 0.8318111300468445, 0,
                -0.03627845644950867, 0.011579737067222595, 0.08550142496824265, 1,
            ],
            radius: 0.021231964230537415,
        },
        'middle-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9876697659492493, -0.06786545366048813, 0.1410750150680542, 0,
                -0.015095947310328484, 0.855663537979126, 0.5173118710517883, 0,
                -0.15582047402858734, -0.5130629539489746, 0.8440889716148376, 0,
                -0.021259509027004242, 0.04587256908416748, 0.03659208118915558, 1,
            ],
            radius: 0.01117393933236599,
        },
        'middle-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.988391637802124, -0.04354291781783104, 0.14555205404758453, 0,
                0.008894841186702251, 0.9729899168014526, 0.23067504167556763, 0,
                -0.15166506171226501, -0.22670257091522217, 0.9620829224586487, 0,
                -0.014570588245987892, 0.06789684295654297, 0.0003578895702958107, 1,
            ],
            radius: 0.008030958473682404,
        },
        'middle-finger-phalanx-distal': {
            offsetMatrix: [
                0.9853697419166565, 0.044260796159505844, 0.16458062827587128, 0,
                -0.0757969319820404, 0.9787378311157227, 0.19059516489505768, 0,
                -0.1526455283164978, -0.20028135180473328, 0.9677740931510925, 0,
                -0.010392282158136368, 0.07414241135120392, -0.026147106662392616, 1,
            ],
            radius: 0.007629410829395056,
        },
        'middle-finger-tip': {
            offsetMatrix: [
                0.9853697419166565, 0.044260796159505844, 0.16458062827587128, 0,
                -0.0757969319820404, 0.9787378311157227, 0.19059516489505768, 0,
                -0.1526455283164978, -0.20028135180473328, 0.9677740931510925, 0,
                -0.0069718430750072, 0.08024183660745621, -0.05014154314994812, 1,
            ],
            radius: 0.006629410665482283,
        },
        'ring-finger-metacarpal': {
            offsetMatrix: [
                0.9616971015930176, -0.13805118203163147, 0.2368120402097702, 0,
                0.0005348679260350764, 0.8648636937141418, 0.5020061135292053, 0,
                -0.2741127610206604, -0.48265108466148376, 0.8318111300468445, 0,
                -0.05402477830648422, 0.015797706320881844, 0.08152295649051666, 1,
            ],
            radius: 0.019088275730609894,
        },
        'ring-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9940828680992126, 0.05735103040933609, 0.09224652498960495, 0,
                -0.10022822767496109, 0.8116500377655029, 0.5754809379577637, 0,
                -0.041867565363645554, -0.5813214182853699, 0.8125960826873779, 0,
                -0.041623555123806, 0.04171867296099663, 0.03582974523305893, 1,
            ],
            radius: 0.00992213748395443,
        },
        'ring-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9843675494194031, 0.12044742703437805, 0.12850022315979004, 0,
                -0.15629759430885315, 0.9337108135223389, 0.3221098482608795, 0,
                -0.08118485659360886, -0.3371586799621582, 0.937940776348114, 0,
                -0.039990875869989395, 0.06438793987035751, 0.004141641780734062, 1,
            ],
            radius: 0.007611672393977642,
        },
        'ring-finger-phalanx-distal': {
            offsetMatrix: [
                0.9748351573944092, 0.11857274919748306, 0.18877571821212769, 0,
                -0.15575434267520905, 0.9681083559989929, 0.19623035192489624, 0,
                -0.15948788821697235, -0.22069483995437622, 0.9622148275375366, 0,
                -0.03783353418111801, 0.07334739714860916, -0.020782606676220894, 1,
            ],
            radius: 0.007231088820844889,
        },
        'ring-finger-tip': {
            offsetMatrix: [
                0.9748351573944092, 0.11857274919748306, 0.18877571821212769, 0,
                -0.15575434267520905, 0.9681083559989929, 0.19623035192489624, 0,
                -0.15948788821697235, -0.22069483995437622, 0.9622148275375366, 0,
                -0.03445569798350334, 0.0802423357963562, -0.04392268508672714, 1,
            ],
            radius: 0.0062310886569321156,
        },
        'pinky-finger-metacarpal': {
            offsetMatrix: [
                0.9181402921676636, 0.35625091195106506, 0.17350243031978607, 0,
                -0.39615097641944885, 0.8352503180503845, 0.38134080171585083, 0,
                -0.009065053425729275, -0.41885748505592346, 0.9080066680908203, 0,
                -0.06191859766840935, 0.013620133511722088, 0.07850203663110733, 1,
            ],
            radius: 0.01808827556669712,
        },
        'pinky-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9714386463165283, 0.236698180437088, -0.016745081171393394, 0,
                -0.18462024629116058, 0.7982627749443054, 0.5733163952827454, 0,
                0.14906984567642212, -0.5538501739501953, 0.8191629648208618, 0,
                -0.061502378433942795, 0.032741155475378036, 0.03705105185508728, 1,
            ],
            radius: 0.008483353070914745,
        },
        'pinky-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9337416291236877, 0.35620439052581787, -0.03527557849884033, 0,
                -0.33203884959220886, 0.8987522721290588, 0.28634607791900635, 0,
                0.13370157778263092, -0.2556603252887726, 0.9574766755104065, 0,
                -0.06608185172080994, 0.049755651503801346, 0.011886020191013813, 1,
            ],
            radius: 0.0067641944624483585,
        },
        'pinky-finger-phalanx-distal': {
            offsetMatrix: [
                0.9419984817504883, 0.3303581774234772, 0.059175245463848114, 0,
                -0.33483216166496277, 0.9130291938781738, 0.23294763267040253, 0,
                0.02292730286717415, -0.2392500638961792, 0.970687210559845, 0,
                -0.0687975287437439, 0.054948460310697556, -0.007561664097011089, 1,
            ],
            radius: 0.0064259846694767475,
        },
        'pinky-finger-tip': {
            offsetMatrix: [
                0.9419984817504883, 0.3303581774234772, 0.059175245463848114, 0,
                -0.33483216166496277, 0.9130291938781738, 0.23294763267040253, 0,
                0.02292730286717415, -0.2392500638961792, 0.970687210559845, 0,
                -0.06947512179613113, 0.0613851435482502, -0.028543535619974136, 1,
            ],
            radius: 0.005425984505563974,
        },
    },
    gripOffsetMatrix: [
        -0.0005348679260350764, -0.8648636937141418, -0.5020061135292053, 0,
        -0.2741127908229828, -0.48265108466148376, 0.8318111896514893, 0,
        -0.9616971015930176, 0.13805119693279266, -0.2368120402097702, 0,
        -0.02878567762672901, 0.0017147823236882687, 0.04536811262369156, 1,
    ],
};
//# sourceMappingURL=relaxed.js.map